import { render, staticRenderFns } from "./ModalEditMailText.vue?vue&type=template&id=1ac2c5b3"
import script from "./ModalEditMailText.vue?vue&type=script&lang=js"
export * from "./ModalEditMailText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports